export const ADD_FOURNISSEUR_SUPPORT = {
  title: {
    ajout: 'Création d\'un fournisseur de support ',
    edit: 'Modification du fournisseur de support ',
  },
  breadcrumb: {
    ajout: 'Création fournisseur de support',
    edit: 'Modification fournisseur de support',
    racine: 'Accueil',
    liste: 'Liste des fournisseurs de support',
  },
  actions: {
    cancel: 'Annuler',
  },
  error: {
    raisonSocial: 'Le champ \'raison social\' est obligatoire.',
    nom: 'Le champ \'nom\' est obligatoire.',
  },
  avertissement: {
    title: 'Attention, l\'IBAN et/ou le BIC du fournisseur de support ont un problème ',
    iban: {
      length: 'La longueur de l\'IBAN n\'est pas correct',
      countryCodeUnsupported: 'Le code de pays de l\'IBAN n\'est pas supporté',
      countryCodeUpperCaseLetters: 'Le code du pays de l\'IBAN doit-être en majuscule',
      invalidCheckDigitValue: 'Les chiffres de contrôle d\' l\'IBAN sont invalides',
      genericError: 'IBAN incorrect : {code}',
    },
    bic: {
      length: 'Le bic doit contenir 8 caractères ou 11 caractères',
      branchCodeOnlyLettersOrDigit: 'Le code de la branche doit contenir seulement des lettres ou des chiffres',
      countryCodeUnsupported: 'Le code de pays du BIC n\'est pas supporté',
      genericError: 'BIC incorrect : {code}',
    },
  },
  informationsGenerales: {
    title: 'Informations générales',
    code: 'Code',
    raisonSociale: 'Raison sociale',
    email: 'Email',
    telephoneFixe: 'Téléphone fixe',
    telephonePortable: 'Téléphone portable',
    civilite: 'Civilité',
    nom: 'Nom',
    prenom: 'Prénom',
    siret: 'Siret',
    applicationTva: 'Application TVA',
  },
  adresse: {
    title: 'Adresses',
    postalAddress: 'Adresse postale',
    addressBillingDifferent: 'Adresse de facturation différente de l\'adresse postale.',
  },
  contact: {
    title: 'Contacts',
    haveAddress: 'Adresse postale différente du fournisseur de support',
  },
  informationsBancaires: {
    title: 'Informations bancaires',
    libelleBanque: 'Libellé banque',
    titulaire: 'Titulaire',
    IBAN: 'IBAN',
    BIC: 'BIC',
    modePaiement: 'Mode de paiement',
    ordreCheque: 'Ordre de chèque',
  },
  infoComptable: {
    title: 'Informations comptables',
    compteComptable: 'Compte comptable',
    referenceUniqueMandat: 'Référence unique mandat',
    dateSignatureMandatSepa: 'Date de signature mandat SEPA',
  },
  infoBlocagePaiement: {
    title: 'Bloquer paiement',
    bloquePaiement: 'Bloquer paiement',
    bloque: 'Bloquer',
    motif: 'Motif de blocage',
  },
  commentaire: {
    title: 'Commentaires',
    commentaire: 'Commentaire',
  },
  notifications: {
    successCreation: 'Création du fournisseur de support réalisée avec succès.',
    successChange: 'Modification du fournisseur de support réalisée avec succès.',
  },
};

export const LISTE_FOURNISSEUR_SUPPORT = {
  title: 'Liste des fournisseurs de support',
  breadcrumb: {
    home: 'Accueil',
    liste: 'Liste des fournisseurs de support',
  },
  actions: {
    add: 'Nouveau fournisseur de support',
    delete: 'Supprimer',
    search: 'Rechercher',
    filtre: 'Filtre',
  },
  tab: {
    code: 'Code',
    nom: 'Nom',
    adresse: 'Adresse',
    ville: 'Ville',
    telephone: 'Téléphone',
    email: 'Email',
    codeComptable: 'Code comptable',
    actions: {
      edit: 'Modifier',
      delete: 'Supprimer',
      archive: 'Archiver',
    },
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    fournisseurs: 'Fournisseur(s) de support',
    archive: 'Archivé',
    ville: 'Ville(s)',
    email: 'Email',
    telephone: 'Téléphone',
    type: 'Type(s)',
    motifBlocage: 'Motif(s) de blocage',
    blocageReglement: 'Blocage paiement',
    compteComptable: 'Compte comptable',
    yes: 'Oui',
    no: 'Non',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  archivage: {
    titleDesarchiver: 'Etes-vous sûr de vouloir désarchiver ce fournisseur de support ?',
    title: 'Etes-vous sûr de vouloir archiver ce fournisseur de support ?',
    desarchiver: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    sucessArchivage: 'Fournisseur de support archivé avec succès',
    sucessDesarchivage: 'Fournisseur de support désarchivé avec succès',
  },
  sousType: {
    pro: 'Professionnel',
    consession: 'Concession',
    prive: 'Particulier',
  },
};

export const DETAIL_FOURNISSEUR_SUPPORT = {
  title: 'Détail {nom}',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des fournisseurs de support',
    detail: 'Détail fournisseur de support',
  },
  actions: {
    edit: 'Modifier',
    marches: 'Liste des marchés',
  },
  titleAccesRapide: 'Accès rapide',
  tabs: {
    detailFournisseurSupport: 'Fournisseur',
    produitFournisseurSupport: 'Produits',
  },
  produit: {
    actions: {
      search: 'Rechercher un produit',
    },
    table: {
      reference: 'Référence',
      type: 'Type',
      label: 'Libellé',
      societe: 'Société',
      agence: 'Agence',
      actif: 'Archivé',
    },
    filtre: {
      categorie: 'Liste des types de produits',
      actif: 'Actif',
      societe: 'Societé',
      actions: {
        search: 'Rechercher',
        reinitialiser: 'Réinitialiser',
        appliquer: 'Appliquer',
      },
      avecLiaisons: 'Avec produit(s) associé(s)',
    },
  },
  steps: {
    infoGenerales: 'Informations générales',
    contacts: 'Contacts',
    infoBancaire: 'Informations bancaires',
    commentaires: 'Commentaires',
    piecesJointes: 'Pièces jointes',
  },
  informationsGenerales: {
    title: 'Informations générales',
    infoAdministrative: 'Informations administrative',
    siret: 'Siret :',
    coordonees: 'Coordonnées',
    email: 'Email :',
    telFixe: 'Téléphone fixe :',
    telPortable: 'Téléphone portable :',
    adresses: 'Adresses',
    adresse: 'Adresse',
    adressePostale: 'Adresse postale :',
    adressePaiement: 'Adresse de paiement :',
    estMairie: 'Mairie',
    applicationTva: 'Application TVA :',
    interne: 'Interne',
  },
  contacts: {
    title: 'Contacts',
  },
  infoBancaire: {
    title: 'Informations bancaires',
    libelleBanque: 'Libellé banque :',
    titulaire: 'Titulaire :',
    iban: 'IBAN :',
    bic: 'BIC :',
    modePaiement: 'Mode de paiement :',
    ordreCheque: 'Ordre de chèque :',
  },
  infoCompta: {
    title: 'Informations comptables',
    compteComptable: 'Compte comptable :',
    referenceUniqueMandat: 'Référence unique mandat :',
    dateSignatureMandatSepa: 'Date de signature mandat SEPA :',
  },
  infoBlocagePaiement: {
    title: 'Bloquer paiement',
    bloquePaiement: 'Bloquer paiement :',
    motif: 'Motif de blocage :',
  },
  commentaires: {
    title: 'Commentaires',
  },
  piecesJointes: {
    title: 'Pièces jointes',
  },
  messages: {
    suppressionDone: 'Le contact a bien été supprimé',
  },
  libelleForLogo: 'Fournisseur {nomCommercial}',
};
